export default __webpack_public_path__ + "static/media/LigeroBg.cfa2a8a1.jpg";